/**
 * feature-config flag names owned by cms-extensibility
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const CMS_EXTENSIBILITY_FLAG_NAMES = {
  CMS_COLLECTION_ITEM_LIMITS: 'ff-cmsext-555-collection-item-limits',
  CMS_PICK_PG_STORAGE_LAYER: 'ff-cmsext-1056-pick-pg-storage-layer',
  CMSEXT_CLOUDFLARE_CACHE_CONTROL: 'ff-cmsext-360-cache-control',
  PREVENT_SITE_INDEXING: 'dyn-5021-prevent-site-indexing',
  CMS_SELECTIVE_PUBLISHING: 'ff-cmsext-956-cms-selective-publishing',
  CMS_SKIP_DBFILES_PUBLISHING: 'ff-cmsext-1379-skip-cms-asset-publishing',
  BATCH_LONG_RUNNING: 'ff-cmsext-1610-batch-long-running',
  CMS_COLLECTION_LIST_PREVIEW: 'ff-cmsext-1482-nova-ux',
  CMS_PICK_PG_ENTERPRISE_STORAGE_LAYER:
    'ff-cmsext-1673-pick-pg-enterprise-storage-layer',
  CMS_USE_MUTATION_RATE_LIMITS: 'ff-cmsext-1420-mutation-rate-limits',
  CMS_PROD_DEBUG_LOGGING: 'ff-cmsext-1429-proddebuglogging',
  CMS_RESTORE_USE_UPSERT: 'ff-cmsext-restore-use-upsert',
  CMS_LAZY_INDEXING: 'ff-cont-5983-lazy-cms-indexing',
  CMS_ICEBOX_SELF_HEAL_GATE: 'ff-cont-6630-icebox-self-heal-gate',
};
